import React from "react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 py-16 px-6 md:px-10 bg-obsidian"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10 md:gap-6 mb-12">
          <div>
            <p className="font-display uppercase tracking-[0.25em] text-sm text-ink-50 mb-3">
              <span className="text-gold">Stop</span> au syndrome de
              l'imposteur
            </p>
            <p className="font-serif italic text-sm text-ink-400 lowercase max-w-xs">
              une capsule sonore pour revenir dans ta puissance.
            </p>
          </div>

          <div className="md:text-center">
            <p className="text-[11px] uppercase tracking-[0.25em] text-ink-400 mb-3">
              Navigation
            </p>
            <ul className="space-y-2 text-sm text-ink-100/90">
              <li>
                <a href="#contenu" className="hover:text-gold transition-colors">
                  L'expérience
                </a>
              </li>
              <li>
                <a href="#protocole" className="hover:text-gold transition-colors">
                  Le protocole
                </a>
              </li>
              <li>
                <a href="#temoignages" className="hover:text-gold transition-colors">
                  Témoignages
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-gold transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div className="md:text-right">
            <p className="text-[11px] uppercase tracking-[0.25em] text-ink-400 mb-3">
              Mentions
            </p>
            <p className="font-serif italic text-xs text-ink-400 max-w-sm md:ml-auto leading-relaxed">
              Cette expérience sonore est un support de développement
              personnel et d'exploration intérieure. Elle ne remplace pas un
              accompagnement médical, psychologique ou thérapeutique adapté en
              cas de souffrance profonde ou de trouble nécessitant un suivi
              professionnel.
            </p>
          </div>
        </div>

        <div className="divider-gold mb-8 opacity-40" />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[11px] uppercase tracking-[0.25em] text-ink-400">
          <p>© 2026–2033 — Tous droits réservés.</p>
          <p className="font-serif italic normal-case tracking-normal text-ink-400/80">
            paiement sécurisé par Stripe · accès immédiat
          </p>
        </div>
      </div>
    </footer>
  );
}
